import DashboardChart from './DashboardChart';
import { useEffect, useRef, useState } from 'react';
import { useDashboardContext } from './Context';
import { DashboardService } from './service';
import moment from 'moment';
import { useAuthContext } from '../../contexts/AuthContext';

const service = new DashboardService();

export const ChatsFaturamentoMes = () => {
    const [loading, setLoading] = useState(false);
    const { selectedDate, atendenteId } = useDashboardContext();
    const competence = moment(selectedDate).format('YYYY-MM');
    const previousCompetenceRef = useRef(competence);
    const { user } = useAuthContext();

    const [state, setState] = useState<any>({
        series: (user?.root || user?.admin) ? [
            {
                name: 'Comissão',
                data: [],
            },
        ] : [
            {
                name: 'Faturamento',
                data: [],
            },
            {
                name: 'Comissão',
                data: [],
            },
        ],
        options: {
            subtitle: {
                text: `Competência: ${moment(competence).format('MMMM [de] YYYY')}`,
                align: 'left',
                margin: 0,
                offsetX: 0,
                offsetY: 0,
                floating: false,
                style: {
                    fontSize: '13px',
                },
            },
            chart: {
                id: 'area',
                type: 'area',
                zoom: {
                    enabled: false,
                },
            },
            colors: ['#007aff', '#af52de'],
            dataLabels: {
                enabled: false,
            },
            markers: {
                size: 0,
                style: 'hollow',
            },
            xaxis: {
                type: 'datetime',
                labels: {
                    format: 'dd/MM/yyyy',
                },
            },
            tooltip: {
                x: {
                    format: 'dd/MM/yyyy',
                },
                y: {
                    formatter: function(val: number) {
                        return val.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                        });
                    },
                },
            },
            yaxis: {
                labels: {
                    formatter: function(y: any) {
                        return y.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                        });
                    },
                },
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'light',
                    inverseColors: false,
                    stops: [0, 100],
                    shadeIntensity: 1,
                    opacityFrom: 0.16,
                    opacityTo: 0.02,
                },
            },
        },
    });

    useEffect(() => {
        const fetchData = async (competence: string, atendenteId?: string) => {
            if (!loading) {
                try {
                    setLoading(true);

                    await service.getFaturamentoMes(competence, atendenteId).then((response) => {
                        const faturamentoData = response.data.map((item: any) => [
                            new Date(item.date).getTime(),
                            item.totalRevenue,
                        ]);

                        const comissaoData = response.data.map((item: any) => [
                            new Date(item.date).getTime(),
                            item.totalCommission,
                        ]);

                        setState((prevState: any) => {
                            prevState.options.subtitle.text = `Competência: ${moment(competence).format('MMMM [de] YYYY')}`;
                            return {
                                ...prevState,
                                series: [
                                    {
                                        ...prevState.series[0],
                                        data: faturamentoData,
                                    },
                                    {
                                        ...prevState.series[1],
                                        data: comissaoData,
                                    },
                                ],
                            };
                        });
                    });
                } catch (e) {
                    console.error('Erro ao buscar dados:', e);
                } finally {
                    setTimeout(function() {
                        setLoading(false);

                        if (previousCompetenceRef.current !== competence) {
                            fetchData(previousCompetenceRef.current);
                        }
                    }, 300);
                }
            }
        };

        previousCompetenceRef.current = competence;
        fetchData(competence, atendenteId);
    }, [competence, atendenteId]);

    return (
        <div id="chart" className={`${loading && 'opacity-30 cursor-not-allowed'}`}>
            <DashboardChart
                key={state.options.subtitle.text}
                options={state.options}
                series={state.series}
                type="area"
                height={350}
            />
        </div>
    );
};
